import React, { Component, Fragment } from 'react';

import { LoaderContext } from './LoaderProvider';

export class PageLoader extends Component<{}> {
  context: any;
  static contextType = LoaderContext;

  componentDidMount() {
    this.context.activate();
  }

  componentWillUnmount() {
    this.context.deactivate();
  }

  render() {
    return <Fragment />;
  }
}
